module.exports = __webpack_public_path__ + "img/brief_icon_hulianwang.0fdb7122.png";